// Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../shared/material.module';
import { MomentModule } from 'ngx-moment';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';

// Components
import { RepairEstimateComponent } from './pages/repair-estimate/repair-estimate.component';
import { FindRepairEstimateComponent } from './pages/find-repair-estimate/find-repair-estimate.component';
import { PhotoPopupComponent } from './components/photo-popup/photo-popup.component';

// Services
import { WsreService } from './wsre.service';

// Pipes
import { UploadPhotoWsreComponent } from './components/upload-photo-wsre/upload-photo-wsre.component';
import { RepairEstimateFrameComponent } from './pages/repair-estimate-frame/repair-estimate-frame.component';
import { UploadPhotoWsreFrameComponent } from './components/upload-photo-wsre-frame/upload-photo-wsre-frame.component';
import { UploadComponentCrackPhotoComponent } from './components/upload-component-crack-photo/upload-component-crack-photo.component';
import { UploadMeasurementCrackPhotoComponent } from './components/upload-measurement-crack-photo/upload-measurement-crack-photo.component';
import { FramecomponentPhotoPopupComponent } from './components/framecomponent-photo-popup/framecomponent-photo-popup.component';
import { AddCrackRecordsDialogComponent } from './components/add-crack-records-dialog/add-crack-records-dialog.component';
import { InterpretationModule } from '../interpretation/interpretation.module';
import { ActionModule } from '../action/action-module';
import { RecordActionHistoryPopup } from './pages/record-action-history-popup/record-action-history-popup.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        MomentModule,
        FormsModule,
        SharedModule,
        InterpretationModule,
        ActionModule,
        BrowserAnimationsModule
    ],
    declarations: [
        RepairEstimateComponent,
        FindRepairEstimateComponent,
        PhotoPopupComponent,
        UploadPhotoWsreComponent,
        RepairEstimateFrameComponent,
        UploadPhotoWsreFrameComponent,
        UploadComponentCrackPhotoComponent,
        UploadMeasurementCrackPhotoComponent,
        FramecomponentPhotoPopupComponent,
        AddCrackRecordsDialogComponent,
      RecordActionHistoryPopup
    ],
    exports: [
        RepairEstimateComponent,
        FindRepairEstimateComponent,
        RepairEstimateFrameComponent
    ],
    providers: [
        WsreService
    ]
})
export class WsreModule { }
